import { ObjectString } from "@/types/genericData";

export const convertJSONStringToArrayString = (objectString: ObjectString): string[] => {
  const header = [];
  for (const i of Object.entries(objectString)) {
    header.push(i[0]);
  }
  return header;
};
